// Definition of all measurement fields, grouped into collapsible sections.

export const SECTIONS = [
  {
    key: "haut",
    label: "HAUT (chemise / boubou / veste)",
    icon: "shirt",
    sexes: ["H", "F"],
    fields: [
      { key: "epaule", label: "Épaule" },
      { key: "tour_cou", label: "Tour de cou" },
      { key: "tour_poitrine", label: "Tour de poitrine" },
      { key: "tour_taille_haut", label: "Tour de taille (haut)" },
      { key: "longueur_manche", label: "Longueur manche" },
      { key: "tour_bras", label: "Tour de bras (biceps)" },
      { key: "tour_poignet", label: "Tour de poignet" },
      { key: "longueur_haut", label: "Longueur haut / chemise" },
      { key: "longueur_boubou", label: "Longueur boubou / grand boubou" },
      { key: "carrure_dos", label: "Carrure dos" },
    ],
  },
  {
    key: "bas",
    label: "BAS (pantalon)",
    icon: "move-vertical",
    sexes: ["H", "F"],
    fields: [
      { key: "tour_ceinture", label: "Tour de ceinture" },
      { key: "tour_hanche", label: "Tour de hanche" },
      { key: "tour_cuisse", label: "Tour de cuisse" },
      { key: "tour_genou", label: "Tour de genou" },
      { key: "bas_pantalon", label: "Bas de pantalon (ouverture)" },
      { key: "longueur_pantalon", label: "Longueur pantalon" },
      { key: "entrejambe", label: "Entrejambe (fourche)" },
    ],
  },
  {
    key: "femme",
    label: "FEMME",
    icon: "flower-2",
    sexes: ["F"],
    fields: [
      { key: "tour_poitrine_dessous", label: "Tour de poitrine (dessous)" },
      { key: "longueur_taille_devant", label: "Longueur taille devant" },
      { key: "longueur_taille_dos", label: "Longueur taille dos" },
      { key: "tour_bassin", label: "Tour de bassin" },
      { key: "longueur_jupe", label: "Longueur jupe / robe" },
      { key: "hauteur_poitrine", label: "Hauteur poitrine" },
      { key: "ecart_poitrine", label: "Écart poitrine" },
    ],
  },
];

// Flatten label lookup for standard fields.
export const LABELS = SECTIONS.reduce((acc, s) => {
  s.fields.forEach((f) => (acc[f.key] = f.label));
  return acc;
}, {});

export function visibleSections(sexe) {
  return SECTIONS.filter((s) => s.sexes.includes(sexe || "H"));
}

const STATUT_LABELS = {
  en_cours: "En cours",
  termine: "Terminé",
  livre: "Livré",
};
export const STATUTS = [
  { value: "en_cours", label: "En cours" },
  { value: "termine", label: "Terminé" },
  { value: "livre", label: "Livré" },
];
export function statutLabel(s) {
  return STATUT_LABELS[s] || s;
}

function formatDateFR(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return "";
  }
}

// Build the clean WhatsApp/clipboard message from measurements (skip empty).
export function buildMesuresMessage(client, atelier) {
  const m = client.mesures || {};
  const lines = [];
  lines.push(`🧵 MESURES — ${client.nom}`);
  if (atelier) lines.push(`🏪 ${atelier}`);
  lines.push(`📅 Mis à jour le ${formatDateFR(client.updatedAt || Date.now())}`);

  const sections = visibleSections(client.sexe);
  sections.forEach((s) => {
    const rows = s.fields
      .filter((f) => m[f.key] !== undefined && m[f.key] !== "" && m[f.key] !== null)
      .map((f) => `• ${f.label} : ${m[f.key]} cm`);
    if (rows.length) {
      lines.push("");
      lines.push(s.label.split(" (")[0].toUpperCase());
      rows.forEach((r) => lines.push(r));
    }
  });

  const customs = (m.custom || []).filter((c) => c && c.nom && c.valeur !== "" && c.valeur !== null);
  if (customs.length) {
    lines.push("");
    lines.push("AUTRES MESURES");
    customs.forEach((c) => lines.push(`• ${c.nom} : ${c.valeur} cm`));
  }

  lines.push("");
  lines.push("✂️ Envoyé via Tailleur Pro");
  return lines.join("\n");
}

export function whatsappUrl(phone, message) {
  const digits = (phone || "").replace(/[^\d]/g, "");
  const text = encodeURIComponent(message);
  return digits ? `https://wa.me/${digits}?text=${text}` : `https://wa.me/?text=${text}`;
}

export function hasAnyMesure(client) {
  const m = client.mesures || {};
  const std = Object.keys(m).some((k) => k !== "custom" && m[k] !== "" && m[k] !== null && m[k] !== undefined);
  const cust = (m.custom || []).some((c) => c && c.nom && c.valeur !== "");
  return std || cust;
}
